module.exports = __webpack_public_path__ + "img/15.e47ef7af.jpg";